import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CxAdvFiltersService } from '../cx-adv-filters.service';

@Component({
    selector: 'cx-view-name-modal',
    templateUrl: 'view-name-modal.component.html',
})
export class CxViewNameComponent {
    @Output() close = new EventEmitter();
    @Output() create = new EventEmitter();

    visible = true;
    constructor (public advFilterService: CxAdvFiltersService) {}

    onCreate(e: MouseEvent) {
        this.create.emit('');
    }
}
